const TextureOverlay = () => {
  return (
    <div 
      className="opacity-5 mix-blend-multiply pointer-events-none fixed inset-0 z-50"
      style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1706271952285-01b5e3fc2d78?crop=entropy&cs=srgb&fm=webp&q=20&w=400')",
        backgroundRepeat: 'repeat'
      }}
      aria-hidden="true"
    />
  );
};

export default TextureOverlay;
